const Product = require('../server-js/data/product')
let defaultTemplates = require('./where-to-buy-templates')

let whereToBuyPath = "/api/v1/product-locations"
let whereToBuyPrefix = ''
if(window.whereToBuyScript) {
	let whereToBuyParts = window.whereToBuyScript.split('/')
	whereToBuyParts.pop()
	whereToBuyParts.pop()
	whereToBuyPrefix = whereToBuyParts.join('/')
}



/**
 * Searches for distributors based on product id, starting zip code,
 * and allowed distance
 */
class ProductSearch {
	constructor({
		controlsBoxSelector = '#where-to-buy-controls',
		resultsBoxSelector = '#where-to-buy-results',
		serverUrl = whereToBuyPrefix + whereToBuyPath,
		templates = defaultTemplates
	} = {}) {

		this.controlsBoxSelector = controlsBoxSelector
		this.resultsBoxSelector = resultsBoxSelector
		this.serverUrl = serverUrl
		this.templates = templates
		
	}
	init() {
		this._drawControls()
		this._addListners()
	}
	
	_drawControls() {
		let controls = document.querySelector(this.controlsBoxSelector)
		if(controls) {
			if(!controls.innerHTML.trim()) {
				controls.innerHTML = this.templates.searchForm()
			}
		}
	}
	_addListners() {
		let form = document.querySelector(this.controlsBoxSelector + ' form')
		form.addEventListener('submit', this.onSubmit.bind(this))
	}
	
	async onSubmit(evt) {
		evt.preventDefault()
		let resultBox = document.querySelector(this.resultsBoxSelector)
		let productId = document.querySelector(this.controlsBoxSelector + ' [name="productId"]').value
		let center = document.querySelector(this.controlsBoxSelector + ' [name="center"]').value
		let distance = document.querySelector(this.controlsBoxSelector + ' [name="distance"]').value
		let result = await fetch(`${this.serverUrl}/${productId}?center=${center}&distance=${distance}`)
		let data = await result.json()
		
		console.log(data)
		if(data.product && data.distributors.length > 0) {
			resultBox.innerHTML = this.templates.distributorsResult(data)
		}
		else if(data.zipUnfound) {
			resultBox.innerHTML = this.templates.noZipCodeResult(data)
		}
		else if(data.product) {
			resultBox.innerHTML = this.templates.noDistributorsResult(data)
		}
		else {
			resultBox.innerHTML = this.templates.noProductResult(data)
		}
	}
	
}

module.exports = ProductSearch